export interface Tome {
  number: string
  title: string
  subtitle: string
  body: string
  fiches: string
  promise: string
  decisive?: boolean
}

export const tomes: Tome[] = [
  {
    number: '01',
    title: 'Les fondations : accueil et diagnostic',
    subtitle: 'De la première prise de contact à la feuille de route',
    body: 'Accueillir un client comme un professionnel dès la première minute. Le Livret d’accueil et les Trois Engagements, le modèle CORE et les 4 niveaux d’une difficulté, les 5 profils de client, la feuille de route co-construite en trois phases, le Point d’Ancrage, et la Séance Zéro minutée en 75 minutes.',
    fiches: 'Fiches 01 à 05',
    promise:
      'Dès la Séance Zéro, votre client sait où il va — et comment il le verra.',
  },
  {
    number: '02',
    title: 'Le cœur : faire évoluer les croyances',
    subtitle: 'De la prise de conscience à une nouvelle façon de se voir',
    body: 'Les 7 croyances limitantes et leur signature comportementale, le protocole de recadrage en 7 étapes, les 5 types de recadrage, l’analyse de l’écart d’identité et douze trames de séance prêtes à adapter. Des repères issus de la recherche, présentés avec prudence : aucune « reprogrammation », aucune promesse.',
    fiches: 'Fiches 06 à 10',
    promise:
      'Quand le client dit « je sais, mais je n’y arrive pas », vous savez quelle séance conduire.',
  },
  {
    number: '03',
    title: 'De la prise de conscience à l’action',
    subtitle: 'La phase Élan : séances 4 à 7',
    body: 'Le bilan de la phase Fondations en séance 3, la trame d’ouverture de la séance 4, les 5 critères d’une micro-expérimentation, le protocole de rebond en 4 temps, les signaux faibles de décrochage, le tableau des progrès et le bilan de mi-parcours.',
    fiches: 'Fiches 11 à 13',
    promise:
      'Le creux de la quatrième séance devient un passage de phase annoncé.',
    decisive: true,
  },
  {
    number: '04',
    title: 'Le client qui stagne',
    subtitle: 'Repères et protocoles pour les moments où rien ne bouge',
    body: 'Plateau ou stagnation, les 5 types de blocage, le protocole d’urgence en 4 temps, la confrontation bienveillante, les réponses par profil, et la fiche Signaux d’orientation pour savoir quand orienter vers un professionnel de santé.',
    fiches: 'Fiches 14 à 16',
    promise:
      'Vous savez lire ce qui bloque — et reconnaître ce qui dépasse le coaching.',
  },
  {
    number: '05',
    title: 'Bien clôturer',
    subtitle: 'La phase Intégration : séances 8 à 10',
    body: 'L’annonce de la fin dès la séance 7, la boîte à outils personnelle, le plan d’autonomie, le bilan de clôture pas à pas, la remise du Journal des ancrages, les témoignages et recommandations dans les règles, la clôture anticipée et la pause.',
    fiches: 'Fiches 17 à 19',
    promise:
      'Votre client repart en sachant dire ce qu’il a obtenu. C’est de là que naît le bouche-à-oreille.',
  },
  {
    number: '06',
    title: 'La pratique professionnelle en France',
    subtitle: 'Offre, cadre légal, déontologie et pilotage',
    body: 'Vendre un parcours plutôt que des séances, la séance découverte sans pression, tarifs et forfaits, micro-entreprise et facturation, contrat d’accompagnement, rétractation et médiation, RGPD, titres protégés et loi du 10 mai 2024, supervision, tableau de bord trimestriel et plan d’action de 30 jours.',
    fiches: 'Fiches 20 à 23',
    promise: 'Un cadre professionnel en règle, écrit pour la France — pas traduit.',
  },
]

export const tomeInclusions = [
  'Des repères pas à pas',
  'Des trames à adapter à votre voix — jamais un texte à réciter',
  'Des fiches imprimables, numérotées de 01 à 23 sur les six tomes',
  'Des supports à utiliser en séance, avec le client',
  'Des repères de déontologie et d’orientation',
]
